import EmptyState from '@components/EmptyState'
import React from 'react'

const EmptyLessons: React.FC<{
  top?: 'xxxs' | 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'xxxl'
  programId?: string
}> = ({ top, programId }) => (
  <EmptyState
    heading="All your live coaching sessions have been completed."
    img="/images/celebration.svg"
    linkUrl={
      programId
        ? `/support/contact-us/?id=my-lessons&pid=${programId}&cat=Reenrolment`
        : `/support/contact-us/?id=my-lessons&pid&cat=Reenrolment`
    }
    btnTxt="Interested in another course?"
    top={top}
  />
)

export default EmptyLessons
